import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { MuiThemeProvider } from "@material-ui/core";
import Card from "@material-ui/core/Card/Card";
import {createMuiTheme} from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import BuildIcon from "@material-ui/icons/Build";
import BlockIcon from "@material-ui/icons/Block";
import CheckIcon from "@material-ui/icons/Check";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";

import { CustomizedSnackbars, ApolloMessage } from "../../../atom/Apollo_Mesasge";
import { ApolloContext } from "../../../atom/Apollo_Context";
import { 
  apollo_useStyles, 
  valueToOption, 
  options_status, 
  options_input_type,
  options_use_preference,
  options_usage,
} from "../../../atom/Apollo_styles";
import { 
  list_poseidon_segments_path, 
  segmentdetailposeidon_path, 
  apollo_users_path,
} from "../../../atom/Apollo_links";
import GenericTemplate from "../../../templates/GenericTemplate";
import { 
  Status,
  CoordinateAccount,
  ListSegment,
  ResListSegment,
} from "../../SEGMENT/poseidon/SegmentModel";
import { ApolloAxios } from "../../../atom/Apollo_ApiRequest3";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import { APOLLO_GROUP_OPERATOR, APOLLO_GROUP_READER } from "../../../atom/Apollo_Authorization";
import {STORAGE_KEY} from "../../../atom/Apollo_DataTable";
import {CsvData, SegmentCustomColumns} from "../../../common/Apollo_CommonConst";
import {valueToLabel} from "../../../common/Apollo_CommonUtil";
import {APOLLO_PAGE_ID, createApolloPageSizeTableOptions} from "../../../common/Apollo_LocalStorageSettings";

import moment from "moment";
import "moment/locale/ja";
import MUIDataTable, { MUISortOptions, SelectableRows } from "mui-datatables";

import {Bars} from "react-loader-spinner";
import {Backdrop} from "@material-ui/core";

/*
    画面名：カスタムセグメント一覧
 */
const CustomSegmentTop: React.FC = () => {
  const history = useHistory();
  const { state } = React.useContext(ApolloContext);
  const { data, setmsg } = React.useContext(ApolloMessage);

  const [segments, setSegments] = useState<ResListSegment[]>([]);
  const [displayUuColumnName, setDisplayUuColumnName] = useState("潜在リーチ数");
  const [roundingUu, setRoundingUu] = useState(true);
  const [coordinateAccounts, setCoordinateAccounts] = useState<CoordinateAccount[]>([]);
  const [progress, setProgress] = useState(false);

  // 潜在リーチ数の丸め処理に使う定数(一万の位まで表示)
  const roundingDigit = 10000

  // 潜在リーチ数表示の場合の丸め処理
  // 画面・CSV出力で使用する共通関数
  const formatUuDisplay = (value: number, isRounding: boolean): string => {
    if (isRounding) {
      if (value < 5000) {
        return "10,000以下";
      }
      // 潜在リーチ数表示の場合は丸め処理(千の位で四捨五入)
      return (Math.round(value / roundingDigit) * roundingDigit).toLocaleString();
    }
    return value.toLocaleString();
  };
  
  const breadcrumbsData: BreadcrumbsData = {
    categoryId: 8,
    breadId: 4,
    queries: [],
    menu: null,
    campaign: null,
    adgroup: null,
    advertisement: null,
    asset: null,
  }

  let coordinateAccounts1: Array<CoordinateAccount> = [];

  React.useEffect(() => {
    // 特定の権限を持ったユーザの場合はUU数をそのまま表示する
    if (state.userprofile.systemAdmin > 0 ||
      state.current.customSegment === 2 && state.current.roleAuthorization >= APOLLO_GROUP_OPERATOR) {
        setDisplayUuColumnName("UU");
        setRoundingUu(false);
    }

    let url: string = apollo_users_path;
    ApolloAxios.get(url).then(response => {
      let result1 = response.data.result;

      // セグメント取得
      var request: ListSegment = {
        usage: "PRODUCTION",
        accountId: state.current.accountId,
        inputType: "",
      };

      setProgress(true);
      url = `${list_poseidon_segments_path}/${state.current.accountGroupId}`;
      ApolloAxios.post(url, request).then(response => {
        let resultCode: number = response.data.resultCode;
        if (resultCode < 0 || resultCode === 2) {
          setProgress(false);
          let type1: string = "error";
          if (resultCode === 2) {
            type1 = "info"
          }

          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: type1,
              message: response.data.message,
            }
          });
          return;
        }

        let segments1: ResListSegment[] = [];

        response.data.result.map((data: any) => {
          // 利用設定 値セット
          let usePreference1: string = "";

          if (data.usePreference !== undefined) {
            if (data.usePreference.length === 1) {
              usePreference1 = valueToOption(data.usePreference[0], options_use_preference).label;
            } else if (data.usePreference.length === 2) {
              usePreference1 = "カスタムリストに利用・除外リストに利用";
            }
          }

          // アカウント連携 値セット
          let coordinated: string = "";

          if (data.coordinatedAccount !== undefined) {
            if (data.coordinatedAccount.length > 0) {
              coordinated = "済";
            }

            let accountNames: string = "";

            let apolloLists: any = state.apolloList;
            data.coordinatedAccount.map((coordinate: any) => {
              for(let apolloList of apolloLists) {
                if (apolloList.accountList === null) {
                  continue;
                }
  
                for(let list of apolloList.accountList){
                  if (coordinate === list.id) {
                    accountNames += list.name + ",";
                    break;
                  }
                };
              };
            });

            if (accountNames.length > 0) {
              accountNames = accountNames.substring(0, accountNames.length-1);
            }
            coordinated += ":::" + accountNames;
          }

          let uuData: number = data.uu;
          if (data.uu === undefined) {
            uuData = 0;
          }

          let updatedBy: string = "";
          result1.map((res1: any) => {
            if (data.updatedBy === res1.userId) {
              updatedBy = res1.familyName+" "+res1.firstName;
            }
          });
          
          let segment1: ResListSegment = {
            id: data.id,
            name: data.name,
            status: data.status,
            uu: uuData,
            coordinatedAccount: coordinated,
            inputType: valueToOption(data.inputType, options_input_type).label,
            usage: valueToOption(data.usage, options_usage).label,
            usePreference: usePreference1,
            fileName: "",
            accountGroupId: data.accountGroupId,
            updatedAt: data.updatedAt,
            updatedBy: updatedBy,
          };
          segments1.push(segment1);
        });

        setCoordinateAccounts(coordinateAccounts1);
        setSegments(segments1);
      }).catch(err => {
        const errMsg = `セグメント情報の取得に失敗しました。`
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg,
          }
        });
      }).finally(() => {
        setProgress(false);
      });
    }).catch(err => {
      const errMsg = `ユーザ情報の取得に失敗しました。`
      setmsg({
        type: "setMessage",
        payload: {
          ...data,
          open: true,
          type: "error",
          message: errMsg,
        }
      });
    }).finally(() => {

    });
  }, []);

  const classes = apollo_useStyles();
  const theme = createMuiTheme({});
  const columns = [
    {
      name: "id",
      label: "ID",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "status",
      label: "ステータス",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return value ? (
            <Tooltip title={valueToOption(value, options_status).label}>
              <span>
                {value === Status.Available ? (
                  <img
                    src={"/img/poseidon/success.png"}
                    alt="利用可"
                    height="32"
                    width="auto"
                  />
                ) : value === Status.Processing ? (
                  <img
                    src={"/img/poseidon/loading.gif"}
                    alt="処理中"
                    height="32"
                    width="auto"
                  />
                ) : (
                  <img
                    src={"/img/poseidon/error.png"}
                    alt="利用不可"
                    height="32"
                    width="auto"
                  />
                )}
              </span>
            </Tooltip>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "name",
      label: "セグメント名",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any) => {
          return (
            <Tooltip title={value}>
              <span>{value}</span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "uu",
      label: displayUuColumnName,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: number) => {
          return formatUuDisplay(value, roundingUu);
        },
      },
    },
    {
      name: "coordinatedAccount",
      label: "アカウント連携",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let accountNames: string = "";
          let doneValue: string = "";

          if (value === "") {
            return;
          }

          let splitVal = value.split(":::");
          accountNames = splitVal[1];
          doneValue = splitVal[0];

          return value !== "" ? (
            <Tooltip title={accountNames}>
              <span>{doneValue}</span>
            </Tooltip>
          ) : ("");
        },
      },
    },
    {
      name: "usage",
      label: "用途設定",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return value ? (
            <div>
            {value === "見積用" ? (
              <p>見積用</p>
            ) : (
              <p>本番用</p>
            )}
            </div>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "inputType",
      label: "タイプ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return value ? (
            <Tooltip title={value}>
              <span>
                {value === "条件指定" ? (
                  <CheckIcon />
                ) : (
                  <InsertDriveFileIcon />
                )}
              </span>
            </Tooltip>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "usePreference",
      label: "利用設定",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          let splitVal: string[] = [];

          if (value !== "") {
            splitVal = value.split("・")
          }

          return value ? (
            <Tooltip title={value}>
              <span>
                {splitVal.length > 1 ?
                  <>
                  <img src={"/img/poseidon/custom_list.png"} alt="setting" height="32" width="32" />
                  <img src={"/img/poseidon/except_list.png"} alt="setting" height="32" width="32" />
                  </>
                : splitVal.length === 1 ?
                  splitVal[0] === "カスタムリストに利用" ? 
                  <img src={"/img/poseidon/custom_list.png"} alt="setting" height="32" width="32" /> : 
                  <img src={"/img/poseidon/except_list.png"} alt="setting" height="32" width="32" />
                : ""
                }
              </span>
            </Tooltip>
          ) : (
            <div></div>
          );
        },
      },
    },
    {
      name: "updatedBy",
      label: "最終更新ユーザ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <p>{value}</p>
          );
        },
      },
    },
    {
      name: "updatedAt",
      label: "最終更新",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: string) => {
          return (
            <Tooltip
              title={moment(value).format("YYYY/MM/DD HH:mm:ss")}
            >
              <span>{moment(value).fromNow()}</span>
            </Tooltip>
          );
        },
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: number, tableMeta: any) => {
          let segmentId: number = tableMeta.rowData[0];
          let isEdit: boolean = false;
          let isPossibleRole: boolean = false;
          let accountGroupId: number = 0;
          let status: string = "";

          if (state.userprofile.systemAdmin > 0 || 
              (state.current.roleAuthorization > APOLLO_GROUP_READER && state.current.customSegment >= 2)) {
            isPossibleRole = true;
          }

          segments.map((segment: any) => {
            if (segment.id === segmentId) {
              accountGroupId = segment.accountGroupId;
              status = segment.status;
            }
          });
          
          if (accountGroupId === state.current.accountGroupId && isPossibleRole) {
            isEdit = true;
          }

          return isEdit ? (
            <Tooltip title="セグメント詳細" placement="top">
              <KeyboardArrowRightIcon
                onClick={() =>
                  history.push(`${segmentdetailposeidon_path}${segmentId}?type=prod`)
                }
                className={classes.link}
                style={{ cursor: "pointer" }}
              />
            </Tooltip>
          ) : (
            ""
          );
        },
      },
    },
  ];

  const sortOrder: MUISortOptions = {
    name: "id",
    direction: "asc",
  };
  const selectableRows: SelectableRows = "none";
  const options = {
    filter: true,
    downloadOptions: {
      filename: `segments_custom.csv`,
      separator: ",",
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      const csvData = formatCsvData(data, segments, roundingUu, formatUuDisplay);
      const csvColumns = getCustomSegmentCsvColumns(displayUuColumnName);
      return "\uFEFF" + buildHead(csvColumns) + buildBody(csvData);
    },
    print: false,
    sort: true,
    sortOrder: localStorage.getItem(STORAGE_KEY.CUSTOM_SEGMENT) ? undefined : sortOrder,
    selectableRows: selectableRows,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50],
    jumpToPage: true,
    expandableRows: false,
    expandableRowsHeader: false,
    expandableRowsOnClick: false,
    storageKey: STORAGE_KEY.CUSTOM_SEGMENT,
    textLabels:{
      body: {noMatch: "該当データが存在しません"}
    },
  };

  return (
    <div>
      <GenericTemplate title={""}>
        <Backdrop className={classes.backdrop2} open={progress}>
          <Bars color="#00BFFF" height={80} width={80} />
        </Backdrop>
        <CustomizedSnackbars />
        <ApolloBreadcrumbs2 data={breadcrumbsData}/>

        <Card className={classes.root} square variant="outlined">
          <MuiThemeProvider theme={theme}>
            <MUIDataTable
              title=""
              data={segments ? segments : []}
              columns={columns}
              options={createApolloPageSizeTableOptions(options, APOLLO_PAGE_ID.CUSTOM_SEGMENT_LIST)}
            />
          </MuiThemeProvider>
        </Card>
      </GenericTemplate>
    </div>
  );
};

// CSV出力用のカラム定義作成機能
// UUカラムのヘッダだけ、画面表示中の名称に合わせて差し替える
// カスタムセグメント一覧画面上のUUカラムはユーザーの権限によって「UU」「潜在リーチ数」に変化するので、
// 画面上の表示によってCSV出力ファイルのカラムも連動して変化するようしている。
// 権限と画面表示の関係性は画面設計書を参照。
// https://docs.google.com/spreadsheets/d/1T_u0ong63Ct3ZY_ZRdmNCSrUiobyGz6B-hYCiunw1A0/edit?gid=502899637#gid=502899637
const getCustomSegmentCsvColumns = (uuLabel: string) => {
  return SegmentCustomColumns.map((column) => {
    if (column.label === "UU") {
      return {
        ...column,
        label: uuLabel,
      };
    }
    return column;
  });
};

// CSVダウンロード機能
const formatCsvData = (
  data: any[],
  tableData: ResListSegment[],
  roundingUu: boolean,
  formatUuDisplay: (value: number, isRounding: boolean) => string,
): CsvData[] => {
  const dataList: CsvData[] = [];
  const segmentMap = new Map<number, ResListSegment>(
    tableData.map((segment) => [segment.id, segment])
  );
  data?.forEach((v: { index: any, data: any[] }) => {
        if (!v.data || v.data.length === 0) return;
        const d = segmentMap.get(v.data[0]);
        if (!d) return;
        let strRelation = "未連携";
        const usePreferenceNames: string[] = [];
        if(d.coordinatedAccount && typeof(d.coordinatedAccount) === "string" && d.coordinatedAccount.indexOf('済') != -1 ) {
          strRelation = "済";
        }
        if(d.usePreference && typeof(d.usePreference) === "string") {
          const preferences = d.usePreference.split("・");
          preferences?.map((preference) => {
            switch (preference) {
              case "カスタムリストに利用":
                usePreferenceNames.push("カスタムリスト");
                break;

              case "除外リストに利用":
                usePreferenceNames.push("除外リスト");
                break;

              default:
                break;
            }
          });
        }

        const list: CsvData = {
          index: v.index,
          data: [
            d.id,
            d.accountGroupId,
            valueToLabel(d.status, options_status),
            d.name,
            formatUuDisplay(d.uu, roundingUu),
            strRelation,
            d.usage,
            d.inputType,
            usePreferenceNames.join("/"),
            d.updatedBy,
            moment(d.updatedAt).format("YYYY-MM-DD HH:mm"),
          ],
        };
        dataList.push(list);
      }
  );
  return dataList;
};

export default CustomSegmentTop;
